// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3H3c5","paymentContainer":"PaymentPage_paymentContainer__28Sp4"};